import { Grid } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { createStyles, makeStyles } from '@material-ui/styles';
import { BackButton } from '../../../../components/BackButton/BackButton';
import { Heading, LoadMore, Option, Select, TextBlock, Loader } from 'neon-design-system';
import { ItemsList } from '../../../../components/ItemsList/ItemsList';
import { ClickableListItem } from '../../../../components/ClickableListItem/ClickableListItem';
import { baseUrls } from '../../../../constants/urls';
import { localDateFormat } from '../../../../utils/date';
import { NoRequestsTile } from '../../../../components/NoRequestsTile/NoRequestsTile';
import { useEffect, useState } from 'react';
import { AccountChangeRequest } from '../../../../types/request';
import { usePaginationRequestInfo } from '../../../../providers/PaginationRequestProvider';
import { activeFilterName } from './AccountChangeRequests';
import { AccountsQueryParams } from '../../../../hooks/useAccountsQuery';

interface Props {
  accountChangeRequests: AccountChangeRequest[];
  options: Option[];
  selectedAccounts: Option[] | null;
  setSelectedAccounts: (option: Option[] | null) => void;
  debounceGetAccounts: (params?: AccountsQueryParams) => Promise<any> | void;
  isFetching: boolean;
}

const useStyles = makeStyles(() =>
  createStyles({
    relative: {
      '& > div ': {
        position: 'relative'
      }
    }
  })
);
export const MobileAccountChangeRequests = (props: Props) => {
  const { accountChangeRequests, selectedAccounts, setSelectedAccounts, options, debounceGetAccounts, isFetching } = props;
  const [mobileAccountChangeRequests, setAccountChangeRequests] = useState<AccountChangeRequest[]>([]);
  const { paginationInfo, setPaginationInfo } = usePaginationRequestInfo(activeFilterName);
  const history = useHistory();
  const classes = useStyles();
  const showMore = () => {
    setPaginationInfo({
      pageNumber: paginationInfo?.pageNumber ? paginationInfo?.pageNumber + 1 : 1,
      pageSize: 15
    });
  };

  useEffect(() => {
    setAccountChangeRequests([...mobileAccountChangeRequests, ...accountChangeRequests]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountChangeRequests]);

  const ShowMoreRequests = () => {
    if (!mobileAccountChangeRequests.length && !accountChangeRequests.length) {
      return <NoRequestsTile />;
    }

    return !mobileAccountChangeRequests.length ? null : (
      <LoadMore
        totalCount={paginationInfo?.totalRecords || 0}
        shownCount={mobileAccountChangeRequests.length}
        buttonText="Show more requests"
        showMore={showMore}
      />
    );
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <BackButton to={'/'} pageName="Support Center" />
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Heading styleName="largeTitle" xs="small">
              Account changes
            </Heading>
          </Grid>
          <Grid item xs={12}>
            <TextBlock styleName="largeBody2" xs="small" shade={400}>
              Below is a list of your requests to transfer trades between accounts.
            </TextBlock>
          </Grid>
          <Grid item xs={12}>
            <Select
              value={selectedAccounts}
              loadOptions={(searchString) => debounceGetAccounts({ searchString })}
              defaultOptions={options}
              placeholder="Select accounts…"
              onChange={(value) => {
                setSelectedAccounts(value);
                setAccountChangeRequests([]);
              }}
              multi
            />
          </Grid>
        </Grid>
      </Grid>
      {!!mobileAccountChangeRequests.length && (
        <Grid item xs={12}>
          <ItemsList>
            {mobileAccountChangeRequests.map((g: any) => (
              <ClickableListItem
                key={g.requestRef}
                title={`Request ${g.requestRef}`}
                status={g.status}
                onClick={() => history.push(`${baseUrls.accountChangeRequests}/${g.requestRef}`)}
              >
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    {localDateFormat(g.requestDate)}
                  </Grid>
                </Grid>
              </ClickableListItem>
            ))}
          </ItemsList>
        </Grid>
      )}
      <Grid item xs={12}>
        {isFetching ? (
          <div className={classes.relative}>
            <Loader />
          </div>
        ) : (
          <ShowMoreRequests />
        )}
      </Grid>
    </Grid>
  );
};
